var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './userItem.module.scss';
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { E_TOOLTIP_POSITION, Tooltip } from 'src/ui/components/ToolTip/Tooltip';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var UserItem = function (props) {
    var i18n = props.i18n, content = props.content, isLocked = props.isLocked, onDelete = props.onDelete, onEdit = props.onEdit;
    var handleTextCopy = function (e, textToCopy) {
        e.stopPropagation();
        navigator.clipboard.writeText(textToCopy);
    };
    var modifyUserTooltip = getPropsByKeyPath(i18n.components, 'tooltips.users.edit');
    var deleteUserTooltip = getPropsByKeyPath(i18n.components, 'tooltips.users.delete');
    return (_jsxs("tr", __assign({ className: classNames(styles.userItemWrapper, isLocked && styles.userItemWrapperDisabled) }, { children: [content.map(function (val, index) { return (_jsx("td", { children: _jsxs("span", __assign({ className: styles.cellItem }, { children: [_jsx("p", __assign({ style: val.style }, { children: val.text })), val.text && _jsx(Icons, { icon: E_ICONS.COPY, className: styles.image, onClick: function (e) { return handleTextCopy(e, val.text); } })] })) }, "".concat(val.text, "-").concat(index))); }), _jsxs("td", __assign({ className: styles.userItemActions }, { children: [_jsxs("span", { children: [_jsx(Tooltip, __assign({ position: E_TOOLTIP_POSITION.LEFT, className: styles.deleteTooltip }, { children: deleteUserTooltip })), _jsx(Icons, { onClick: onDelete, className: styles.images, icon: E_ICONS.TRASH, color: COLORS.RED['500'] })] }), _jsxs("span", { children: [_jsx(Tooltip, __assign({ position: E_TOOLTIP_POSITION.LEFT }, { children: modifyUserTooltip })), _jsx(Icons, { onClick: onEdit, className: styles.images, icon: E_ICONS.EDIT, color: COLORS.PRIMARY['500'] })] })] }))] })));
};
